import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Alert, Card, CardBody, CardFooter, CardHeader } from 'reactstrap'

//Dependencies.
import getVideoId from 'get-video-id';
import { useSelector } from 'react-redux';

//Images.
import winnerImage from "../../../images/winner-image.jpg"

//Slice - Data
import { challengesState } from '../../../slices/challengesSlice';

import { store } from '../../../app/store';

import './ChallengeCoverCard.styles.css';


const ChallengeCoverCard = ({...props}) => {
   const location = useLocation();
   const navigate = useNavigate();
   const sliceState = useSelector(challengesState);
   const storeState = store.getState();

   if (location.pathname.includes("announcements")) {
      const {
         _challengeID,
         _ownerID,
         coverImageDetails: { imageLink },
         upcomingChallengeProperties: {
            challengeAnnouncementEndDate,
            challengeAnnouncementHeadline,
            daysRemainingBeforeAnnouncementEnds
         }
      } = props;

      return (
         <Card className='challengeCardContainer'>
            <CardHeader className='p-0'>
               <img src={imageLink} className='challengeCardImage' alt="challenge card image" />
            </CardHeader>
            <CardBody className='p-1' style={{backgroundColor: 'bisque', textAlign: 'center'}}>
               <strong>{ challengeAnnouncementHeadline.length > 37 ? challengeAnnouncementHeadline.substring(0, 34) + "..." : challengeAnnouncementHeadline }</strong>
            </CardBody>
            <CardFooter>
               <strong>Announcement Ends on {challengeAnnouncementEndDate}.</strong>
            </CardFooter>
         </Card>         
      )
   }
   else if (location.pathname.includes("active") || location.pathname.includes("actives")) {
      const {
         _challengeID,
         _ownerID,
         coverImageDetails: { imageLink },
         activeChallengeProperties: {
            activeChallengeDaysRemaining,
            activeChallengeEndDate,
            howWillChallengeEnd,
            winningVotes,
            title
         }
      } = props;
      
      return (
         <Card className='challengeCardContainer'>
            <CardHeader className='p-0'>
               <img src={imageLink} className='challengeCardImage' alt="challenge card img." />
            </CardHeader>
            <CardBody className='p-1' style={{backgroundColor: 'bisque'}}>
               <strong>{title}</strong>
               <div />
               <strong>Challenge ends { activeChallengeEndDate ? ` on ${activeChallengeEndDate}.` : ` when a video gets ${winningVotes} votes.` }.</strong>
            </CardBody>
            <div className="d-grid gap-2 gap-sm-0 col-lg-12 p-lg-1 p-sm-0 mx-auto" style={{overflow: 'hidden'}}>
               <button className="btn btn-danger" type="button">SEE MORE DETAILS...</button>
            </div>
         </Card>
      )
   }
   else if (location.pathname.endsWith("completed")) {
      const {
         _ownerID,
         coverImageDetails: { imageLink },
         activeChallengeProperties: {
            title,
            winner
         }
      } = props;

      if ((Object.values(winner).length) && (Object.values(winner)[0].link)) {
         //The Object.keys(winner)[0] != "TIE" is because, inside _videoIDWinner located inside updateWinnerStatusForExpiredChallenges of miscellaneousFunctions.js, the key is TIE if the challengeWinner function returns { }.
         const { id } = getVideoId(Object.values(winner)[0]?.link)

         if (!sliceState.isLoading) {
            return (
               <Card className='challengeCardContainer'>
                  <CardHeader className='p-0'>
                     {
                        id ?
                        <img src={`https://img.youtube.com/vi/${id}/maxresdefault.jpg`} className='challengeCardImage' alt="challenge card img." />
                        :
                        <img src={winnerImage} className='challengeCardImage' alt='img of winner' />
                     }                  
                  </CardHeader>
                  <CardBody>
                     <h3 className='text-danger'>{ title }</h3>
                     <h5>WINNER: { Object.values(winner)[0].title }</h5>
                  </CardBody>
                  <CardFooter>
                     <strong><span className='text-danger'>Challenge Owner: </span></strong>
                     <strong>{ _ownerID }.</strong>
                  </CardFooter>
               </Card>
            )
         } else {
            return (
               <>
                  <Alert color='danger' style={{ border: '3px solid black' }}>
                     <h3>Please be patient as we upload completed challenges...</h3>
                  </Alert>
                  <Card className='challengeCardContainer'>
                     <CardHeader>
                        <img src={`https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/SMPTE_Color_Bars.svg/1200px-SMPTE_Color_Bars.svg.png`} className='challengeCardImage' alt="challenge card img." />
                     </CardHeader>
                     <CardBody>
                        <h5><i>LOADING...</i> please be patient.</h5>
                     </CardBody>
                  </Card>
               </>
               
            )
         }
         
      }
      else {
         return (
            <Card className='challengeCardContainer'>
               <CardHeader className='p-0'>
                  <img src="https://creazilla-store.fra1.digitaloceanspaces.com/cliparts/39398/tie-clipart-xl.png" className='challengeCardImage' alt="It's a TIE!!!" />
               </CardHeader>
               <CardBody>
                  <h3 className='text-danger'>{ title }</h3>
                  <h5>IT'S A TIE!!!</h5>
               </CardBody>
               <CardFooter>
                  <strong><span className='text-danger'>Challenge Owner: </span></strong>
                  <strong>{ _ownerID }.</strong>
               </CardFooter>
            </Card>
         )
      }  
   }
   else {
      navigate("/");

      return (
         <>
            <h1>BACK TO HOME PAGE.</h1>
         </>
      )
   }
}

export default ChallengeCoverCard